var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"患者端","name":"1"}},[_c('PatientView')],1),_c('el-tab-pane',{attrs:{"label":"医生端","name":"2"}},[_c('DoctorView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }